/*
  This creates the ability to use ${breakpoints('lg')``} in a styled-component.
  To use a max-width query instead of min-width, dev can use tnDown | xsDown | smDown | ...etc as arguments instead.

  Usage:

  Below adds text center style component for large (and up) screens:
  const Component = styled(Card)`
    ${breakpoints('lg')`
      text-align:center;
    `}
  `

  Below adds text center style component for screens smaller than large:
  const Component = styled(Card)`
    ${breakpoints('lgDown')`
      text-align:center;
    `}
  `

  TODO: Move into Hive to be able to take advantage of breakpoints method anywhere
*/

interface Sizes {
  [key: string]: number
}

const sizes: Sizes = {
  tn: 320,
  xs: 375,
  sm: 425,
  semiMd: 500,
  md: 768,
  lg: 1024,
  xl: 1440,
  xxl: 1920,
  xxxl: 2560,
};

const ScreenSizes: Sizes = {};

Object.keys(sizes).forEach((value: keyof typeof sizes) => {
  const sizeDownKey = `${value}Down`;
  ScreenSizes[value] = sizes[value];
  ScreenSizes[sizeDownKey] = sizes[value] - 1;
});

export const breakpoints = (key: keyof typeof ScreenSizes) => {
  let type: string;

  if (typeof key === 'string' && key.includes('Down')) {
    type = 'max';
  } else {
    type = 'min';
  }

  return (style: TemplateStringsArray | String) => `@media (${type}-width: ${ScreenSizes[key]}px) { ${style} }`;
};

export { ScreenSizes };
